import script from "./DmReceived.vue?vue&type=script&setup=true&lang=js"
export * from "./DmReceived.vue?vue&type=script&setup=true&lang=js"

import "./DmReceived.vue?vue&type=style&index=0&id=4084d7fa&scoped=true&lang=css"
import "./DmReceived.vue?vue&type=style&index=1&id=4084d7fa&lang=less"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4084d7fa"]])

export default __exports__